import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { UitkFlatButton } from 'uitk-react-button';
import { ClickTracker } from 'bernie-analytics';
const ButtonTracked = ClickTracker(UitkFlatButton);

export class MyList extends React.Component {
  public render() {
    return (
      <div className="my-list">
        <ButtonTracked id="my-list-button" rfrr="PWA.Header.MyList" href="/lists" linkName="My List" data-stid="my-list-button">
          <UitkIcon name="favorite" className="my-list__icon" />
          <span className="is-visually-hidden">My List</span>
        </ButtonTracked>
      </div>
    );
  }
}
